module.exports = __webpack_public_path__ + "static/media/d6bb78c1d64640ad06cc8cdd1c61b67d.d6bb78c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/d6bb78c1d64640ad06cc8cdd1c61b67d.svg
// module id = 1239
// module chunks = 21